import React from 'react';
import { Button } from '@mui/material';
import { CloseButton } from '../../../components/UI-Elements/Buttons/CloseButton';

export const HelpPopup: React.FC<{ close: () => void }> = ({ close }) => (
  <div className="flex bg-white rounded p-3 flex-col gap-3">
    <div className="flex justify-between font-semibold">
      <h3 className="font-bold text-lg mb-2">Admin Change Data Help</h3>
      <CloseButton onClick={close} />
    </div>
    <i>this screen has few tools to help admin manage data: </i>
    <p>
      <b>1. Add financial positions</b> = opens a popup to add financial positions to materials
    </p>
    <div className="flex flex-col">
      <p>
        <b>2. Recalc exposure of </b>
        <i>(logged-in account)</i> = triggers exposure calculation for current account and all its materials
      </p>
      <p className="pl-4">run this when there are problems in the exposure calc in the dashboard </p>
      <p className="pl-4">it triggers the backend calculation for current account</p>
    </div>

    <div className="flex flex-col">
      <p>
        <b>3. Run monthly test ALL ACCOUNTS</b> = triggers a monthly exposure calc for all accounts and materials
      </p>
      <p className="pl-4">run this when there are problems in the exposure calc in the dashboard </p>
      <p className="pl-4">
        it triggers the backend calculation for <b>ALL ACCOUNTS - it&apos;s a heavy calculation</b>
      </p>
    </div>

    <div className="flex flex-col">
      <p>
        <b>4. Generate future order Exposure for: </b>
        <i>(Selected account)</i> = calculates and saves future orders exposure table for selected account
        <i>(selected in the left drop down)</i>
      </p>
      <p className="pl-4">
        this action can be ran many times, it overwrites the current `<i>FO Exposure</i>` - so its safe to re run it. no
        duplicates are created
      </p>
    </div>

    <div className="flex flex-col">
      <p>
        <b>5. Build exposure history for: </b>
        <i>(Selected account)</i> = calculates and saves exposure history for selected account
      </p>
      <p className="pl-4">
        this action can be ran many times, it overwrites the current `<i>exposure history</i>` - so its safe to re run
        it. no duplicates are created
      </p>
    </div>
    <p>
      <b>6. Clear logs...</b>
    </p>
    <p>
      <b>7. Show existing exposures</b> = fetches and displays existing exposure history for selected account
    </p>
    <div className="flex flex-1 justify-center">
      <Button variant="contained" onClick={close}>
        Close
      </Button>
    </div>
  </div>
);
